import { firebaseServices } from "./firebase";
interface setData {
  name?: string,
  date?: string | number,
  age?: number,
  email?: string,
  password?: string,
  country?: string,
  city?: string,
  address?: string,
  url?: string,
}


export class firebaseHandler {
    static getBlogData = () => {
      let callData = firebaseServices.functions.httpsCallable('callBlogData')
      return callData()
      .then((result: any) => {
        // Read result of the Cloud Function.
        // console.log(result)
        return result.data;
      })
      .catch((e) => {
        console.log(`this is our error: ${e}`)
        return undefined;
      })
    }
    static checkPassword = async (password: string | null) => {
      let canPass = firebaseServices.functions.httpsCallable('checkPassword')
      const can = await canPass({password: password});
      return can;
    }
    static createPost = async ({title, summary, content}: any) => {
      let addPost = firebaseServices.functions.httpsCallable('createPost')
      const newDoc = await addPost({title, summary, content})
      return newDoc;
    }
    static savePost = async ({id, title, summary, content}: any) => {
      let saveEdits = firebaseServices.functions.httpsCallable('savePost')
      const result = await saveEdits({id, title, summary, content})
      return result.data;
    }
    static saveIncompletePost = async ({title, summary, content}: any) => {
      let saveIncomplete = firebaseServices.functions.httpsCallable('saveIncompletePost')
      const result = await saveIncomplete({title, summary, content})
      return result.data;
    }
    static grabIncompletePost = async () => {
      let grabIncomplete = firebaseServices.functions.httpsCallable('grabIncompletePost')
      const result = await grabIncomplete();
      return result.data;
    }
}